import { gql } from "@apollo/client";

export const UPDATE_GESTION_INICIO = gql`
mutation updateGestionInicio($input: UpdateGestionInicioInput!) {
    updateGestionInicio(input: $input){
        idEvaluacion
    }
}`;

export const adaptGestionInicioInput = (idEvaluacion, gestionInicioData) => ({
  idEvaluacion,
  idMDemora: gestionInicioData?.idMDemora,
  observacionMDemora: gestionInicioData?.observacionMDemora,
  idNIngreso: gestionInicioData?.idNIngreso,
  idRechazoNIngreso: gestionInicioData?.idRechazoNIngreso,
  observacionNIngreso: gestionInicioData?.observacionNIngreso
});